import React, { useState, createContext, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import SkeletonLoader from './components/SkeletonLoader';
import BottomNavBar from './components/BottomNavBar';
import '@fortawesome/fontawesome-free/css/all.min.css';

// Import the notification components
// import NotificationsComponent from './components/NotificationsComponent';
// import NotificationSender from './components/NotificationSender';
// import { AuthProvider, AuthContext } from './context/AuthContext';

// Lazy load the pages
const Welcome = lazy(() => import('./pages/Welcome'));
const Login = lazy(() => import('./pages/Login'));
const Register = lazy(() => import('./pages/Register'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const ProfileInfo = lazy(() => import('./pages/ProfileInfo'));
const PlayGame = lazy(() => import('./pages/PlayGame'));
const GameLevel = lazy(() => import('./pages/GameLevel'));
const Congratulations = lazy(() => import('./pages/Congratulations'));
const Sorry = lazy(() => import('./pages/Sorry'));
const Leaderboard = lazy(() => import('./pages/Leaderboard'));
const ReferralLink = lazy(() => import('./pages/ReferralLink'));
const AboutUs = lazy(() => import('./pages/AboutUs'));
const Winners = lazy(() => import('./pages/Winners'));
const CustomerService = lazy(() => import('./pages/CustomerService'));

// Create a context to manage loading state
export const LoadingContext = createContext();

const App = () => {
  const [loading, setLoading] = useState(false);
  // const [notificationCount, setNotificationCount] = useState(0);

  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      {/* <AuthProvider> */}
        <Router>
          <Suspense fallback={<SkeletonLoader />}>
            <AppContent 
              // notificationCount={notificationCount} 
              // setNotificationCount={setNotificationCount} 
            />
          </Suspense>
        </Router>
      {/* </AuthProvider> */}
    </LoadingContext.Provider>
  );
};

const AppContent = ({ notificationCount, setNotificationCount }) => {
  const location = useLocation();
  const hideNavBarPaths = ['/', '/login', '/register'];
  // const { user } = useContext(AuthContext);

  return (
    <>
      <Routes>
        <Route path="/" element={<Welcome />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/profile" element={<ProfileInfo />} />
        <Route path="/play-game" element={<PlayGame />} />
        <Route path="/play-level/:level" element={<GameLevel />} />
        <Route path="/congratulations" element={<Congratulations />} />
        <Route path="/sorry" element={<Sorry />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/referrallink" element={<ReferralLink />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/winners" element={<Winners />} />
        <Route path="/customerservice" element={<CustomerService />} />
        {/* Add more routes as needed */}
      </Routes>
      {!hideNavBarPaths.includes(location.pathname) && <BottomNavBar />}
      {/* {user && <NotificationsComponent setNotificationCount={setNotificationCount} />}
      {user && <NotificationSender />} Render NotificationSender only if user is defined */}
    </>
  );
};

export default App;







// // src/App.js
// import React, { useState, createContext, lazy, Suspense } from 'react';
// import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
// import SkeletonLoader from './components/SkeletonLoader';
// import BottomNavBar from './components/BottomNavBar';
// import '@fortawesome/fontawesome-free/css/all.min.css';


// // Lazy load the pages
// const Welcome = lazy(() => import('./pages/Welcome'));
// const Login = lazy(() => import('./pages/Login'));
// const Register = lazy(() => import('./pages/Register'));
// const Dashboard = lazy(() => import('./pages/Dashboard'));
// const ProfileInfo = lazy(() => import('./pages/ProfileInfo'));
// const PlayGame = lazy(() => import('./pages/PlayGame'));
// const GameLevel = lazy(() => import('./pages/GameLevel'));
// const Congratulations = lazy(() => import('./pages/Congratulations'));
// const Leaderboard = lazy(() => import('./pages/Leaderboard'));
// const ReferralLink = lazy(() => import('./pages/ReferralLink'));
// const AboutUs = lazy(() => import('./pages/AboutUs'));
// // const CustomerService = lazy(() => import('./pages/CustomerService'));

// // Create a context to manage loading state
// export const LoadingContext = createContext();

// const App = () => {
//   const [loading, setLoading] = useState(false);

//   return (
//     <LoadingContext.Provider value={{ loading, setLoading }}>
//       <Router>
//         <Suspense fallback={<SkeletonLoader />}>
//           <AppContent />
//         </Suspense>
//       </Router>
//     </LoadingContext.Provider>
//   );
// };

// const AppContent = () => {
//   const location = useLocation();
//   const hideNavBarPaths = ['/', '/login', '/register'];

//   return (
//     <>
//       <Routes>
//         <Route path="/" element={<Welcome />} />
//         <Route path="/login" element={<Login />} />
//         <Route path="/register" element={<Register />} />
//         <Route path="/dashboard" element={<Dashboard />} />
//         <Route path="/profile" element={<ProfileInfo />} />
//         <Route path="/play-game" element={<PlayGame />} />
//         <Route path="/play-level/:level" element={<GameLevel />} />
//         <Route path="/congratulations" element={<Congratulations />} />
//         <Route path="/leaderboard" element={<Leaderboard />} />
//         <Route path="/referrallink" element={<ReferralLink />} />
//         <Route path="/aboutus" element={<AboutUs />} />
//         {/* <Route path="/customer-service" element={<CustomerService />} /> */}
//         {/* Add more routes as needed */}
//       </Routes>
//       {!hideNavBarPaths.includes(location.pathname) && <BottomNavBar />}
//     </>
//   );
// };

// export default App;





// // src/App.js
// import React from 'react';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import Welcome from './pages/Welcome';
// import Login from './pages/Login';
// import Register from './pages/Register';
// import Dashboard from './pages/Dashboard'; // Create this component later
// import ProfileInfo from './pages/ProfileInfo'; // Create this component later
// import PlayGame from './pages/PlayGame';
// import GameLevel from './pages/GameLevel';
// import Congratulations from './pages/Congratulations';
// import Leaderboard from './pages/Leaderboard';
// import ReferralLink from './pages/ReferralLink';
// import AboutUs from './pages/AboutUs';
// import Navbar from './components/Navbar'; // Create this component later

// const App = () => {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/" element={<Welcome />} />
//         <Route path="/login" element={<Login />} />
//         <Route path="/register" element={<Register />} />
//         <Route path="/dashboard" element={<Dashboard />} />
//         <Route path="/profile" element={<ProfileInfo />} />
//         <Route path="/play-game" element={<PlayGame />} />
//         <Route path="/play-level/:level" element={<GameLevel />} />
//         <Route path="/congratulations" element={<Congratulations />} />
//         <Route path="/leaderboard" element={<Leaderboard />} />
//         <Route path="/referrallink" element={<ReferralLink />} />
//         <Route path="/aboutus" element={<AboutUs />} />
//         {/* Add more routes as needed */}
//       </Routes>
//     </Router>
//   );
// };

// export default App;





















// import logo from './logo.svg';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;
